var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasteMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 15,
    viewBox: "0 0 27 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26313 2.33496L8.96461 7.01561C6.77265 8.38082 5.29459 10.7858 5.22357 13.5415H0C0 8.80248 2.50525 4.65213 6.26313 2.33496Z",
    fill: "#FFD460"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3029 1.91325L16.5972 6.60626C15.5535 6.10094 14.3884 5.81712 13.1527 5.81712C11.9127 5.81712 10.7392 6.10095 9.69544 6.61047L6.98975 1.9214C8.82712 0.944451 10.9231 0.38916 13.1527 0.38916C15.3738 0.38916 17.47 0.940242 19.3029 1.91325Z",
    fill: "#FFD460"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3044 13.5413H21.0811C21.01 10.7815 19.5278 8.368 17.3274 7.007L20.0289 2.33057C23.7949 4.64353 26.3044 8.79808 26.3044 13.5413Z",
    fill: "#EA7E86"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5396 12.1775C11.9772 12.5203 11.8023 13.2521 12.1482 13.8142C12.4968 14.3803 13.2317 14.5578 13.7941 14.2148L14.1634 13.8657L18.489 9.73145L12.8692 12.0413L12.5396 12.1775Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasteMeter);
export default __webpack_public_path__ + "static/media/taste_meter.e47c180f03127adc8821c08987d7751f.svg";
export { ForwardRef as ReactComponent };